export default function LoggingIn() {
    return <p className="text-white">Logging in...</p>;
}